/*
 * Project: BookingEngine
 * Module: components/booking/rooms/PromoCodeDetail.js*/

import React from 'react';
import PropTypes from 'prop-types';

import '../../../static/less/promocode.less';

const PromoCodeDetail = ({ code, description }, context) => (
  <div className="PromoCodeDetail">
    <h3 className="PromoCodeDetail__title">{context.t('Applied Promocode')}:<span className="PromoCodeDetail__code"> {code.toUpperCase()}</span></h3>
    <p className="PromoCode__description text-justify">
      {description}
    </p>
  </div>
);

PromoCodeDetail.contextTypes = {
  t: PropTypes.func.isRequired,
};

PromoCodeDetail.propTypes = {
  code: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default PromoCodeDetail;
